import {Component, Input, OnInit} from '@angular/core';
import {GetDuplicateClaimsService} from "./get-duplicate-claims.service";
import {NgForOf, NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";
import {
  GetDuplicateClaimsDto
} from "../../../auto-generated-server-dtos/claim/duplicate-detection/get-duplicate-claims-dto";
import {DuplicateClaimDto} from "../../../auto-generated-server-dtos/claim/duplicate-detection/duplicate-claim-dto";

@Component({
  selector: 'app-repair-centre-duplicate-claims',
  standalone: true,
  imports: [
    NgIf,
    NgForOf,
    RouterLink
  ],
  templateUrl: './duplicate-claims.component.html',
  styleUrl: './duplicate-claims.component.scss'
})
export class DuplicateClaimsComponent implements OnInit {
  @Input() claimId!: number;
  public claimsPortalClaimDuplicatesOnVehicleFromSameRepairCentreWithinTimeFrame: DuplicateClaimDto[] = [];

  constructor(private getDuplicateClaimsService: GetDuplicateClaimsService) {
  }

  ngOnInit(): void {
    this.getDuplicateClaimsService.getDuplicateClaims(this.claimId).subscribe((duplicateClaims: GetDuplicateClaimsDto) => {
      this.claimsPortalClaimDuplicatesOnVehicleFromSameRepairCentreWithinTimeFrame = duplicateClaims.claimsPortalClaimDuplicatesOnVehicleFromSameRepairCentreWithinTimeFrame;
    });
  }

}
